import type { SupportedLocale } from '../locales/locale';

export function legalDocumentForLocale(
  locale: SupportedLocale,
  documents: Record<SupportedLocale, string>,
): string {
  return documents[locale];
}
